import type { CheckoutStep, PrescriptionOrderType } from "./checkout.schemas";
import { checkoutDiagnoseStepsByPrescriptionOrderType } from "./constants";
import type { CheckoutStepDiagnoseStepByPrescriptionOrderType } from "./types";

export function canNavigateToPath(
	pathname: string,
	checkoutSteps: Readonly<CheckoutStep[]>,
	completedSteps: string[] = [],
): boolean {
	const [_, __, stepName] = pathname.split("/");
	const pathnameIndex = checkoutSteps.findIndex((step) =>
		step.includes(stepName),
	);

	if (pathnameIndex === 0) return true;

	return Boolean(
		completedSteps.find((step) =>
			step.includes(checkoutSteps[pathnameIndex - 1]),
		),
	);
}

export function getDiagnoseSteps(
	prescriptionOrderType: PrescriptionOrderType = "initial",
) {
	return checkoutDiagnoseStepsByPrescriptionOrderType[prescriptionOrderType];
}

export function getDiagnoseStepIndex<T extends PrescriptionOrderType>(
	type: T,
	step: CheckoutStepDiagnoseStepByPrescriptionOrderType<T>,
): number {
	const steps = checkoutDiagnoseStepsByPrescriptionOrderType[
		type
	] as readonly CheckoutStepDiagnoseStepByPrescriptionOrderType<T>[];

	return steps.indexOf(step);
}

export function getCheckoutType(): "normal" {
	return "normal";
}
